// Small presentational pieces of the case brief. Moved unchanged out of CaseBriefPage.js (ticket 072).
import React from 'react'

export function BriefSection({ title, children }) {
  return (
    <div className="brief-section">
      <div className="brief-section-header">
        <div className="brief-section-title">{title}</div>
      </div>
      <div className="brief-section-body">{children}</div>
    </div>
  )
}

export function FactGroup({ title, facts }) {
  if (!facts || facts.length === 0) return null
  return (
    <div className="brief-fact-group">
      {title && <div className="brief-fact-group-title">{title}</div>}
      {facts.map(({ label, value }) => (
        <div key={label} className="brief-fact-row">
          <span className="brief-fact-label">{label}</span>
          <div className="brief-fact-value">{value}</div>
        </div>
      ))}
    </div>
  )
}

// Form + Status only — no Basis column. line2 (short subtitle) still
// carries just enough context to identify the item without re-explaining
// the rule to a professional.
export function FindingsTable({ findings }) {
  if (!findings || findings.length === 0) {
    return <p className="brief-empty-note">No findings available.</p>
  }
  return (
    <div className="brief-findings-wrap">
      <table className="brief-findings-table">
        <thead>
          <tr>
            <th className="brief-findings-th">Form</th>
            <th className="brief-findings-th">Status</th>
          </tr>
        </thead>
        <tbody>
          {findings.map((f, i) => (
            <tr key={i} className="brief-findings-tr">
              <td className="brief-findings-td">
                <div className="brief-findings-area">{f.line1}</div>
                {f.line2 && <div className="u-desc-xs">{f.line2}</div>}
              </td>
              <td className="brief-findings-td brief-findings-td-nowrap">
                <span className={`brief-status ${f.status.cls}`}>{f.status.label}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

// `link` (optional): { href, label } — "View as client saw it ↗", the
// public-token link to what the client actually saw/submitted (D2). Kept
// distinct from ScenariosCard's "View scenario →" in-app peek button —
// external client-facing view vs. in-app scenario switch are different
// actions and must read as such.
export function SourceCardHeader({ title, sub, completed, badge = 'Completed', badgeClass = '', link }) {
  return (
    <div className="brief-source-card-header">
      <div>
        <div className="brief-source-card-title">{title}</div>
        {sub && <div className="brief-source-card-sub">{sub}</div>}
        {link && (
          <a href={link.href} target="_blank" rel="noopener noreferrer" className="u-text-link">
            {link.label}
          </a>
        )}
      </div>
      {completed && <span className={`brief-source-card-badge${badgeClass ? ` ${badgeClass}` : ''}`}>{badge}</span>}
    </div>
  )
}
